module.exports = __webpack_public_path__ + "img/IEDEMFND.776c89f5.png";